import { Grid } from '@mui/material';
import AcademicsClassesAndCoursesGrid from './academicsClassesAndCoursesGrid.view';

const AcademicsClassesAndCourses = () => {
  return (
    <Grid container spacing={{ xs: 1, sm: 2 }} data-testid="academics-classes-courses-view">
      <Grid item xs={12}>
        <AcademicsClassesAndCoursesGrid />
      </Grid>
    </Grid>
  );
};

export default AcademicsClassesAndCourses;
